export const promoOfferContexts = {
  detailsDownload: 'details-download',
  detailsAddToFolder: 'details-add-to-folder',
  cardDownload: 'card-download',
  cardAddToFolder: 'card-add-to-folder',
  detailsDropbox: 'details-dropbox',
  topNav: 'top-nav',
  homepage: 'homepage',
};

export const stockItemFormats = {
  MP3: 'MP3',
  WAV: 'WAV',
};

export const contentTypes = {
  FOOTAGE: 'footage',
  TEMPLATE: 'template',
  MOTION_BG: 'motionbackground',
  VR_360: 'vr360',
  ILLUSTRATION: 'illustration',
  VECTOR: 'vector',
  PHOTO: 'photo',
  SNAPSHOT: 'snapshot',
  SOUND_EFFECT: 'sfx',
  MUSIC: 'music',
};

export const userFriendlySearchTypes = {
  FOOTAGE: 'Footage',
  TEMPLATE: 'Template',
  MOTION_BG: 'Motion BG',
  VR_360: 'VR 360',
  ILLUSTRATION: 'Illustration',
  VECTOR: 'Vector',
  PHOTO: 'Photo',
  SNAPSHOT: 'Snapshot',
  SOUND_EFFECT: 'Sound Effects',
  MUSIC: 'Music',
};

export const contentTypeRoutes = {
  FOOTAGE: 'video',
  ILLUSTRATIONS: 'illustrations',
  MOTION_BG: 'motion-graphics',
  PHOTOS: 'photos',
  SOUND_EFFECT: 'sound-effects',
  TEMPLATE: 'templates',
  VECTORS: 'vectors',
  VR_360: 'footage',
};

export const paymentMethods = {
  CARD: 1,
  CHECK: 2,
  WIRE: 3,
  PAYPAL: 4,
};

// corresponds to values defined in SubscriptionPaymentType.php
export const paymentFlows = {
  UPGRADE: 'upgrade',
  REACTIVATE: 'reactivate,',
};

export const mouseEventsKey = {
  MOUSE_DOWN: 'mousedown',
};

// Placeholder poster image for performance optimization during video loading
export const posterPlaceholderDataUri = `data:image/jpeg;base64,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`;

// e.g. https://github.com/jrylan/http-method-enum/
export enum HTTPMethod {
  /**
   * The `CONNECT` method establishes a tunnel to the server identified by the
   * target resource.
   */
  CONNECT = 'CONNECT',

  /**
   * The `DELETE` method deletes the specified resource.
   */
  DELETE = 'DELETE',

  /**
   * The `GET` method requests a representation of the specified resource.
   * Requests using GET should only retrieve data.
   */
  GET = 'GET',

  /**
   * The `HEAD` method asks for a response identical to that of a GET request,
   * but without the response body.
   */
  HEAD = 'HEAD',

  /**
   * The `OPTIONS` method is used to describe the communication options for the
   * target resource.
   */
  OPTIONS = 'OPTIONS',

  /**
   * The PATCH method is used to apply partial modifications to a resource.
   */
  PATCH = 'PATCH',

  /**
   * The `POST` method is used to submit an entity to the specified resource,
   * often causing a change in state or side effects on the server.
   */
  POST = 'POST',

  /**
   * The `PUT` method replaces all current representations of the target
   * resource with the request payload.
   */
  PUT = 'PUT',

  /**
   * The `TRACE` method performs a message loop-back test along the path to the
   * target resource.
   */
  TRACE = 'TRACE',
}
